"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime.js");

var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js"));

var _position = _interopRequireDefault(require("./components/contract/position"));

var _record = _interopRequireDefault(require("./components/contract/record.vue"));

var _index = require("@/model/exchange/index");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  data: function data() {
    return {
      active: 1,
      contractMap: {},
      listType: [{
        text: "当前持仓",
        val: 1
      }, {
        text: "交易记录",
        val: 2
      }]
    };
  },
  components: {
    Position: _position.default,
    Record: _record.default
  },
  created: function created() {
    this.getAssets();
    this.startAssetsTimer();
  },
  methods: {
    onTypeChange: function onTypeChange(val) {
      this.active = val;
    },
    startAssetsTimer: function startAssetsTimer() {
      var _this = this;

      this.getAssets().then(function () {
        var timer = setTimeout(function () {
          _this.startAssetsTimer();
        }, 500);

        _this.$once("hook:beforeDestroy", function () {
          clearTimeout(timer);
        });
      });
    },
    getAssets: function getAssets() {
      var _this2 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params, _yield$apiGetAssets, status, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // if (!this.userInfo) {
                //   return;
                // }
                params = {
                  type: "all"
                };
                _context.next = 3;
                return (0, _index.apiGetAssets)(params);

              case 3:
                _yield$apiGetAssets = _context.sent;
                status = _yield$apiGetAssets.status;
                data = _yield$apiGetAssets.data;

                if (status == 200) {
                  _this2.contractMap = data.contract;
                }

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};
exports.default = _default;